import type { AsyncDuckDBConnection } from "@duckdb/duckdb-wasm";
import { arrowTableToObjects } from "../utils/arrow";
import { exportToCsv } from "./csv";

/**
 * Execute `sql` (already LIMIT-ed!) and immediately trigger a CSV browser download.
 * Uses Arrow → plain objects → exportToCsv() which handles proper quoting.
 */
export async function downloadQueryToCsv(
  conn: AsyncDuckDBConnection,
  sql: string,
  filename: string = "data.csv"
) {
  const res   = await conn.query(sql);          // Arrow result
  const rows  = arrowTableToObjects(res);       // → JS objects
  if (!rows.length) return;

  const cols  = Object.keys(rows[0]);
  exportToCsv(rows, cols, filename.endsWith(".csv") ? filename : `${filename}.csv`);
}
